export const NAV = {
  logo: "nav-logo",
  shop: "nav-shop",
  categories: "nav-categories",
  contact: "nav-contact",
  account: "nav-account",
  cartButton: "nav-cart-button",
  cartCount: "nav-cart-count",
  loginLink: "nav-login-link",
  logoutBtn: "nav-logout-btn",
  adminLink: "nav-admin-link",
};

export const SHOP = {
  search: "shop-search-input",
  categoryFilter: "shop-category-filter",
  grid: "shop-product-grid",
  card: (id) => `product-card-${id}`,
  addToCart: (id) => `add-to-cart-${id}`,
};

export const PRODUCT = {
  title: "product-title",
  price: "product-price",
  addToCart: "product-add-to-cart",
  qty: "product-qty-input",
  buyNow: "product-buy-now",
};

export const CART = {
  drawer: "cart-drawer",
  item: (id) => `cart-item-${id}`,
  remove: (id) => `cart-remove-${id}`,
  qtyPlus: (id) => `cart-qty-plus-${id}`,
  qtyMinus: (id) => `cart-qty-minus-${id}`,
  subtotal: "cart-subtotal",
  checkoutBtn: "cart-checkout-btn",
  emptyState: "cart-empty",
};

export const CHECKOUT = {
  form: "checkout-form",
  name: "checkout-name",
  email: "checkout-email",
  phone: "checkout-phone",
  company: "checkout-company",
  line1: "checkout-line1",
  line2: "checkout-line2",
  city: "checkout-city",
  state: "checkout-state",
  postal: "checkout-postal",
  country: "checkout-country",
  notes: "checkout-notes",
  submit: "checkout-submit-btn",
  success: "checkout-success",
  successBadge: "checkout-success-badge",
  polling: "checkout-polling",
};

export const AUTH = {
  emailInput: "auth-email-input",
  passwordInput: "auth-password-input",
  nameInput: "auth-name-input",
  companyInput: "auth-company-input",
  phoneInput: "auth-phone-input",
  submitBtn: "auth-submit-btn",
  errorMsg: "auth-error-msg",
};

export const ADMIN = {
  root: "admin-dashboard",
  statRevenue: "admin-stat-revenue",
  statMargin: "admin-stat-margin",
  statOrders: "admin-stat-orders",
  statPending: "admin-stat-pending",
  ordersTable: "admin-orders-table",
  productsTable: "admin-products-table",
  fulfillBtn: (id) => `admin-fulfill-${id}`,
  tabOrders: "admin-tab-orders",
  tabProducts: "admin-tab-products",
  tabContacts: "admin-tab-contacts",
};

export const CONTACT = {
  form: "contact-form",
  name: "contact-name",
  email: "contact-email",
  company: "contact-company",
  phone: "contact-phone",
  message: "contact-message",
  submit: "contact-submit-btn",
  success: "contact-success",
};
